export default{
    getOutputText: state => {
        return state.outputChatMessages
    },
    getCurrentText: state => {
        return state.outputChatMessages[state.outputChatMessagesIndex]
    },
}